import * as React from 'react';
import Skeleton from 'telstra-ui/components/skeleton/Skeleton';

const supportedTableTypes = {
    basic: 'basic',
    accordion: 'accordion'
}

interface ITableSkeletonProps {
    type?: string;
    columns?: number;
    rows?: number;
    subRows?: number;
}

const TableSkeletonLoader: React.FC<ITableSkeletonProps> = (props: ITableSkeletonProps) => {
    const defaultConfigs = {
        rows: props.rows ? props.rows : 5,
        columns: props.columns ? props.columns : 6,
        subRows: props.subRows ? props.subRows : 2,
        width: '120px',
        height: '20px'
    }

    const createTableHeader = () => {
        const tableHeader = [];
        for (let i = 0; i < defaultConfigs.columns; i++) {
            const header = (
            <div key={i} className="tc-st-skeleton-header">
                    <Skeleton width={defaultConfigs.width} height={defaultConfigs.height}/>
            </div>
            );
            tableHeader.push(header)
        }
        return tableHeader;
    }

    const createTableRow = () => {
        const rows = [];
        for (let i = 0; i < defaultConfigs.columns; i++) {
            const cell = (
            <div key={i} className="tc-st-skeleton-cell">
                    <Skeleton width={defaultConfigs.width} height={defaultConfigs.height}/>
            </div>
            );
            rows.push(cell);
        }
        return rows;
    }

    const createAccordianTableRow = () => {
        const rows = [];
        for (let j = 0; j < defaultConfigs.subRows; j++) {
            const row = (
            <div key={j} className="tc-st-accordian-sub-container">{createTableRow()}</div>
            );
            rows.push(row);
        }
        return (
            <div className="tc-st-accordian-row">
                <div className="tc-st-accordian-row-title">
                    <Skeleton width="400px" height={defaultConfigs.height}/>
                </div>
                <div className="tc-st-accordian-sub-row">{rows}</div>
            </div>
        );
    }

    const createTableBody = () => {
        const tableBody = [];
        if (props.type === supportedTableTypes.basic) {
            for (let i = 0; i < defaultConfigs.rows; i++) {
                const row = <div key={i} className="tc-st-skeleton-row">{createTableRow()}</div>
                tableBody.push(row);
            }
        }
        if (props.type === supportedTableTypes.accordion) {
            for (let i = 0; i < defaultConfigs.rows; i++) {
                const row = <div key={i} className="tc-st-skeleton-row">{createAccordianTableRow()}</div>
                tableBody.push(row);
            }
        }
        return tableBody;
    }

    const createTableSkeleton = () => {
        return (
            <div>
                <div className="tc-st-skeleton-table-header">{createTableHeader()}</div>
                <div className="tc-st-skeleton-table-body">{createTableBody()}</div>
                <div className="tc-st-skeleton-pagination">
                    <div><Skeleton width="300px" height={defaultConfigs.height}/></div>
                    <div><Skeleton width="300px" height={defaultConfigs.height}/></div>
                </div>
            </div>
        );
    }

    return (
        <div className="tc-st-table-skeleton-container">
                {createTableSkeleton()}
        </div>
    )
}

export default TableSkeletonLoader;
